import Vue from 'vue';
import {
    AlertPlugin,
    ButtonGroupPlugin,
    ButtonPlugin,
    ButtonToolbarPlugin, FormGroupPlugin, FormInputPlugin,
    FormPlugin, FormRadioPlugin, InputGroupPlugin,
    ModalPlugin,
    SpinnerPlugin
} from "bootstrap-vue/esm";

Vue.use(FormPlugin);
Vue.use(SpinnerPlugin);
Vue.use(AlertPlugin);
Vue.use(ModalPlugin);
Vue.use(ButtonGroupPlugin);
Vue.use(ButtonPlugin);
Vue.use(ButtonToolbarPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(FormRadioPlugin);
Vue.use(InputGroupPlugin);
